import { TFunction } from "i18next";
import { FC, useState, useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { ROUTES } from "../../routes";
import { currentLanguage } from "../../i18n/type";
import { useSeo } from "../../shared/components/UseSeoComponent";
import "./style.css";

interface AboutPageProps {
  maxWidth: number;
  screenWidth: number;
  screenHeight: number;
  t: TFunction<"translation", undefined>;
}

const AboutPage: FC<AboutPageProps> = (props: AboutPageProps) => {
  const { t, maxWidth, screenWidth, screenHeight } = props;
  const navigate = useNavigate();
  const [experienceCount, setExperienceCount] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  useSeo("aboutPage");

  useEffect(() => {
    // Sayfa yüklendiğinde animasyonu başlat
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 500);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (isVisible) {
      // Tecrübe sayısını 0'dan 10'a kadar animasyonlu olarak artır
      const interval = setInterval(() => {
        setExperienceCount(prev => {
          if (prev < 16) {
            return prev + 1;
          }
          clearInterval(interval);
          return prev;
        });
      }, 200); // Her 200ms'de bir artır

      return () => clearInterval(interval);
    }
  }, [isVisible]);

  const handleContactClick = () => {
    navigate(`/${currentLanguage}/${ROUTES.contact[currentLanguage]}`);
  };

  return (
    <>
      {window.location.pathname.endsWith(ROUTES.about[currentLanguage]) ? (
        <div className="about-page-container" style={{ maxWidth: maxWidth }}>
          <div className="about-content">
            {/* Sol Bölüm - Fotoğraf */}
            <div className="about-image-section">
              <div className="profile-image-container">
                <img
                  src="/images/hakkımızda.jpg"
                  alt="Hakkımızda"
                  className="profile-image"
                  onError={(e) => {
                    e.currentTarget.src = "https://via.placeholder.com/400x500/f0f0f0/cccccc?text=Hakkımızda";
                  }}
                />
              </div>
            </div>

            {/* Sağ Bölüm - İçerik */}
            <div className="about-text-section">
              <h1 className="about-title">{t("aboutPage.title")}</h1>
              
              <p className="about-description">
                {t("aboutPage.description")}
              </p>

              <div className={`experience-section ${isVisible ? 'animate' : ''}`}>
                <div className="experience-number">{experienceCount}</div>
                <div className="experience-label">{t("aboutPage.experience")}</div>
              </div>

              <button 
                className="contact-button"
                onClick={handleContactClick}
              >
                {t("aboutPage.contactButton")}
              </button>
            </div>
          </div>

          {/* Alt Bölüm - Ek Metin */}
          <div className={`additional-text-section ${isVisible ? 'animate' : ''}`}>
            <p className="additional-text">
              {t("aboutPage.additionalText")}
            </p>
          </div>


        </div>
      ) : (
        <Outlet />
      )}
    </>
  );
};

export default AboutPage;
